import React from "react";

import When from "./utils/When";
import ContextMenu from "./ContextMenu";
import { ORIENTATION_VERTICAL, PLACEMENT_BOTTOM } from "../constants/UIConstants";
import AppConstants from "../constants/AppConstants";

const { LAYOUT_DESKTOP } = AppConstants;

export const ToggleSyncContextMenu = ({
  orientation = ORIENTATION_VERTICAL,
  placement = PLACEMENT_BOTTOM,
  sync,
  layout,
  toggleSync,
}) => (
  <When it={sync !== undefined}>
    <ContextMenu orientation={orientation} placement={placement}>
      <When it={!sync}>
        <button
          type="button"
          className="drop-down-button"
          title={`Click to merge desktop and mobile values using current ${layout} values`}
          onClick={toggleSync}
          style={{ textAlign: "center" }}
        >
          Merge Using {layout === LAYOUT_DESKTOP ? "Desktop" : "Mobile"}
        </button>
      </When>
      <When it={sync}>
        <button
          type="button"
          className="drop-down-button"
          title="Click to split desktop and mobile values"
          onClick={toggleSync}
          style={{ textAlign: "center" }}
        >
          Split Mobile &amp; Desktop
        </button>
      </When>
    </ContextMenu>
  </When>
);
